// extracted by mini-css-extract-plugin
export default {"list":"list---cCd_h","listContainer":"listContainer---MUtRy"};